/** Every quarter hour of the day, "HH:MM", for time pickers that must work the same in every browser. */
export const QUARTER_HOURS = Array.from({ length: 96 }, (_, i) =>
  `${String(Math.floor(i / 4)).padStart(2, "0")}:${String((i % 4) * 15).padStart(2, "0")}`,
);

/** The quarter hours plus the current value when it is an odd minute (e.g. 09:29 from an older event). */
export function quarterHourOptions(current?: string | null) {
  const value = (current ?? "").slice(0, 5);
  return /^\d{2}:\d{2}$/.test(value) && !QUARTER_HOURS.includes(value) ? [...QUARTER_HOURS, value].sort() : QUARTER_HOURS;
}

/** "9:30 a.m." */
export function timeLabel(value: string) {
  const [hours, minutes] = value.split(":").map(Number);
  return `${hours! % 12 || 12}:${String(minutes).padStart(2, "0")} ${hours! < 12 ? "a.m." : "p.m."}`;
}
